module.exports = __webpack_public_path__ + "img/max_box_1.d1c70fdb.png";